import React, { useState, useEffect } from 'react'
import { IconButton, Icon, Panel, ButtonGroup, Row, Col, Input } from 'rsuite'
import { cloneDeep } from 'lodash-es'
import { budgetFormat } from '../../utils/formatterUtil'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import NumberFormat from 'react-number-format'
import notification from '../../utils/notification'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function StrategyRegisterTable({ schema, isEdit, onSave = () => {}, ...props }) {
  const [formSchema, setFormSchema] = useState(schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isShowDeleteConfirm, setIsShowDeleteConfirm] = useState(false)
  const [listExpanded, setListExpanded] = useState()

  const [selectDeleteIndex, setSelectDeleteIndex] = useState()
  const [editCategoryCostId, setEditCategoryCostId] = useState()
  const [editSubActivity, setSubEditActivity] = useState()
  const [editActivityBudget, setEditActivityBudget] = useState()
  const [editActivityCode, setEditActivityCode] = useState()
  const [saveReq, setSaveReq] = useState()

  useEffect(() => {
    var map = new Map()
    schema?.forEach((item, index) => {
      item?.values?.forEach((mainItem, mainIndex) => {
        map.set(item.key + '_' + index + '_' + mainIndex, false)
      })
    })

    // console.log('map : ', map)
    setListExpanded(map)
    setFormSchema(schema)
  }, [schema])

  const handleEditActivity = (key, mainVal) => {
    var map = cloneDeep(listExpanded)

    for (let mkey of map.keys()) {
      map.set(mkey, false)
    }

    map.set(key, !map.get(key))
    //console.log('key : ', key, ' mainVal : ', mainVal)
    setSubEditActivity(mainVal.subActivity)
    setEditActivityBudget(mainVal.activityBudget)
    setEditActivityCode(mainVal.activityCode)
    setEditCategoryCostId(mainVal.categoryCostId)

    setListExpanded(map)
  }

  const handleViewActivity = (key) => {
    var map = cloneDeep(listExpanded)

    map.set(key, !map.get(key))

    setListExpanded(map)
    setEditActivityBudget(0)
  }

  const onAddSubActivity = (index, activity) => {
    var act = cloneDeep(editSubActivity)

    act.push({
      id: 'ADD_' + (index + 1),
      //masterId: '',
      subActivityCode: '',
      subActivityName: '',
      subActivityBudget: 0,
      subActivityUsedBudget: 0,
      deletable: true,
    })

    setSubEditActivity(act)
  }

  const onDeleteSubActivity = (index) => {
    var act = cloneDeep(editSubActivity)

    //act[index]
    act.splice(index, 1)

    setSubEditActivity(act)
    setSelectDeleteIndex('')
  }

  const onSubmit = () => {
    //let request

    let sum = 0
    let isHaveNull = false
    let errorAlerts = []

    editSubActivity?.forEach((e) => {
      sum += e.subActivityBudget
      if (!e.subActivityName) {
        isHaveNull = true
      }

      if (isLessThenUsed(e)) {
        errorAlerts.push(
          `กิจกรรม ${e.subActivityCode} ยอดเงิน ${budgetFormat(
            e.subActivityBudget
          )} ไม่สามารถน้อยกว่ายอดที่ใช้ไปแล้ว ${budgetFormat(e.subActivityUsedBudget)}`
        )
      }
    })

    console.log(errorAlerts)

    if (isHaveNull) {
      notification.open('error', {
        title: `กรุณาระบุชื่อกิจกรรมย่อยให้ครบ`,
        duration: 5000,
      })
    } else if (sum > editActivityBudget) {
      notification.open('error', {
        title: `ยอดรวมกิจกรรมย่อย ${budgetFormat(sum)} เกินยอดของกิจกรรมหลัก ${budgetFormat(
          editActivityBudget
        )}`,
        duration: 5000,
      })
    } else if (errorAlerts.length > 0) {
      errorAlerts.forEach((e) => {
        setTimeout(() => {
          notification.open('error', {
            title: e,
            duration: 5000,
          })
        }, 100)
      })
    } else {
      let req = {
        categoryCostId: editCategoryCostId,
        activityCode: editActivityCode,
        subActivities: editSubActivity,
      }

      console.log(req)
      setSaveReq(req)
      setIsShowConfirm(true)
      // onSave(req)
    }
  }

  const onChange = (value, name, subIndex) => {
    let editA = cloneDeep(editSubActivity)

    editA[subIndex][name] = value

    setSubEditActivity(editA)
  }

  const isLessThenUsed = (obj) => {
    if (
      !obj.id.startsWith('ADD_') &&
      (obj.subActivityBudget || 0) < (obj.subActivityUsedBudget || 0)
    ) {
      console.log('t')
      return true
    }
    return false
  }

  const headerCell = {
    // borderStyle: 'none dashed none none',
    borderStyle: 'solid solid solid solid',
    //backgroundColor: '#f2f1f1',
    borderColor: '#f2f1f1',
    borderWidth: '1px',
  }

  const detailBorderCell = {
    borderStyle: 'none solid solid solid',
    borderColor: '#f2f1f1',
    borderWidth: '1px',
  }

  const detailCell = {
    borderStyle: 'none none none none',
  }

  const headerDetail = { padding: 8, fontWeight: '550', textAlign: 'center' }

  return (
    <>
      {formSchema?.map((item, index) => {
        // console.log('item ', item)
        return (
          <>
            <div key={index} style={{ marginBottom: 10 }}>
              <Panel bordered defaultExpanded collapsible header={item.header}>
                <Row>
                  {item.values.map((mainVal, mainIndex) => {
                    return (
                      <>
                        {/* header */}
                        {mainIndex == 0 && (
                          <Row className="rs-table-row-header" style={{ ...headerCell }}>
                            <Col lg={4} md={4} sm={24} xs={24}>
                              <div style={headerDetail}>รหัสยุทธศาตร์/กิจกรรม</div>
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <div style={{ ...headerDetail, textAlign: 'left' }}>
                                ชื่อยุทธศาสตร์/กิจกรรม
                              </div>
                            </Col>
                            <Col lg={4} md={4} sm={24} xs={24}>
                              <div style={{ ...headerDetail, textAlign: 'right' }}>
                                งบประมาณ (บาท)
                              </div>
                            </Col>
                            <Col lg={4} md={4} sm={24} xs={24}>
                              <div style={headerDetail}>จัดการข้อมูล</div>
                            </Col>
                          </Row>
                        )}

                        <Row style={detailBorderCell}>
                          <Col lg={4} md={4} sm={24} xs={24} style={{ ...detailCell }}>
                            {/* รหัสยุทธศาตร์/กิจกรรม */}
                            <div style={{ padding: 8, textAlign: 'center' }}>
                              {mainVal.activityCode}
                            </div>
                          </Col>
                          <Col lg={12} md={12} sm={24} xs={24} style={{ ...detailCell }}>
                            {/* ชื่อยุทธศาสตร์/กิจกรรม */}
                            <div style={{ padding: 8, textAlign: 'left' }}>
                              {mainVal.activityName}
                            </div>
                          </Col>
                          <Col lg={4} md={4} sm={24} xs={24} style={{ ...detailCell }}>
                            {/* งบประมาณ (บาท) */}
                            <div style={{ padding: 8, textAlign: 'right' }}>
                              {budgetFormat(mainVal.activityBudget)}
                            </div>
                          </Col>
                          <Col lg={4} md={4} sm={24} xs={24} style={{ ...detailCell }}>
                            <div style={{ padding: 8, textAlign: 'center' }}>
                              {/* จัดการข้อมูล */}
                              <ButtonGroup>
                                {listExpanded?.get(`${item.key}_${index}_${mainIndex}`) ? (
                                  <IconButton
                                    //id={`SUB_${mainVal.activityCode}_SUB_${mainIndex}_BUTTON_CANCEL`}
                                    appearance="ghost"
                                    className="rs-btn-ghost-cancel"
                                    icon={
                                      <Icon
                                        icon={isEdit ? 'warning' : 'eye-slash'}
                                        className="bt-gost-icon-none-radius-cancel"
                                      />
                                    }
                                    onClick={(e) => {
                                      handleViewActivity(`${item.key}_${index}_${mainIndex}`)
                                    }}
                                    size="sm"
                                  >
                                    {isEdit ? 'ยกเลิก' : 'ซ่อน'}
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    //id={`SUB_${mainVal.activityCode}_SUB_${mainIndex}_BUTTON_EDIT`}
                                    appearance="ghost"
                                    className={isEdit ? 'rs-btn-ghost-edit' : 'rs-btn-ghost'}
                                    icon={
                                      <Icon
                                        icon={isEdit ? 'edit' : 'eye'}
                                        className={
                                          isEdit
                                            ? 'bt-gost-icon-radius-edit'
                                            : 'bt-gost-icon-radius'
                                        }
                                      />
                                    }
                                    onClick={(e) => {
                                      var key = `${item.key}_${index}_${mainIndex}`
                                      if (isEdit) {
                                        handleEditActivity(key, mainVal)
                                      } else {
                                        handleViewActivity(key)
                                      }
                                    }}
                                    size="sm"
                                  >
                                    {isEdit ? 'แก้ไข' : 'แสดง'}
                                  </IconButton>
                                )}
                              </ButtonGroup>
                            </div>
                          </Col>
                        </Row>
                        {listExpanded?.get(`${item.key}_${index}_${mainIndex}`) && (
                          <Row style={detailBorderCell}>
                            <Col lg={2} md={2} sm={24} xs={24} style={detailCell}>
                              {/* รหัสยุทธศาตร์/กิจกรรม */}
                              <div style={{ padding: 8, textAlign: 'center' }}></div>
                            </Col>
                            <Col lg={20} md={20} sm={24} xs={24} style={detailCell}>
                              {/* ชื่อยุทธศาสตร์/กิจกรรม */}
                              <div style={{ padding: 8, textAlign: 'left' }}>
                                <div style={{ marginBottom: 10 }}>
                                  <Row className="rs-table-row-header" style={{ ...headerCell }}>
                                    <Col lg={4} md={4} sm={24} xs={24}>
                                      <div style={headerDetail}>รหัสกิจกรรมย่อย</div>
                                    </Col>
                                    <Col
                                      lg={isEdit ? 10 : 13}
                                      md={isEdit ? 10 : 13}
                                      sm={24}
                                      xs={24}
                                    >
                                      <div style={{ ...headerDetail, textAlign: 'left' }}>
                                        ชื่อกิจกรรมย่อย
                                      </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={24} xs={24}>
                                      <div style={{ ...headerDetail, textAlign: 'right' }}>
                                        งบประมาณ (บาท)
                                      </div>
                                    </Col>
                                    <Col lg={3} md={3} sm={24} xs={24}>
                                      <div style={{ ...headerDetail, textAlign: 'right' }}>
                                        ใช้ไปแล้ว (บาท)
                                      </div>
                                    </Col>
                                    {isEdit && (
                                      <Col lg={3} md={3} sm={24} xs={24}>
                                        <div style={headerDetail}>จัดการข้อมูล</div>
                                      </Col>
                                    )}
                                  </Row>

                                  {isEdit ? (
                                    <>
                                      {editSubActivity?.map((subVal, subIndex) => {
                                        return (
                                          <>
                                            <Row style={detailBorderCell}>
                                              <Col lg={4} md={4} sm={24} xs={24}>
                                                <div
                                                  style={{
                                                    padding: 8,
                                                    textAlign: 'center',
                                                  }}
                                                >
                                                  {subVal.subActivityCode || '******'}
                                                </div>
                                              </Col>
                                              <Col lg={10} md={10} sm={24} xs={24}>
                                                <div
                                                  style={{
                                                    padding: 8,
                                                    textAlign: 'left',
                                                  }}
                                                >
                                                  <Input
                                                    key={`subActivityName_${subVal.id}`}
                                                    placeholder="ชื่อกิจกรรมย่อย"
                                                    defaultValue={subVal.subActivityName || ''}
                                                    value={subVal.subActivityName || ''}
                                                    onChange={(value) => {
                                                      onChange(value, 'subActivityName', subIndex)
                                                    }}
                                                  />
                                                </div>
                                              </Col>
                                              <Col lg={4} md={4} sm={24} xs={24}>
                                                <div
                                                  style={{
                                                    padding: 8,
                                                    textAlign: 'right',
                                                  }}
                                                >
                                                  <NumberFormat
                                                    className="rs-input"
                                                    placeholder="งบประมาณ"
                                                    thousandSeparator={true}
                                                    decimalScale={2}
                                                    value={subVal.subActivityBudget}
                                                    style={{
                                                      textAlign: 'right',
                                                      color: isLessThenUsed(subVal)
                                                        ? '#fb8a81'
                                                        : '',
                                                    }}
                                                    onValueChange={(value) => {
                                                      onChange(
                                                        value.floatValue,
                                                        'subActivityBudget',
                                                        subIndex
                                                      )
                                                    }}
                                                  />
                                                </div>
                                              </Col>

                                              <Col lg={3} md={3} sm={24} xs={24}>
                                                <div
                                                  style={{
                                                    padding: 8,
                                                    textAlign: 'right',
                                                    marginTop: 10,
                                                  }}
                                                >
                                                  {budgetFormat(subVal.subActivityUsedBudget || 0)}
                                                </div>
                                              </Col>

                                              <Col lg={3} md={3} sm={24} xs={24}>
                                                <div
                                                  style={{
                                                    padding: 8,
                                                    textAlign: 'center',
                                                  }}
                                                >
                                                  {subVal.deletable && (
                                                    <ButtonGroup>
                                                      <IconButton
                                                        appearance="ghost"
                                                        className="rs-btn-ghost-cancel"
                                                        icon={
                                                          <Icon
                                                            icon="trash-o"
                                                            className="bt-gost-icon-none-radius-cancel"
                                                          />
                                                        }
                                                        onClick={(e) => {
                                                          console.log(editSubActivity[subIndex])
                                                          setSelectDeleteIndex(subIndex)
                                                          setIsShowDeleteConfirm(true)
                                                          //onDeleteSubActivity(subIndex)
                                                        }}
                                                        size="sm"
                                                        disabled={!subVal.deletable}
                                                      >
                                                        ลบ
                                                      </IconButton>
                                                    </ButtonGroup>
                                                  )}
                                                </div>
                                              </Col>
                                            </Row>
                                          </>
                                        )
                                      })}
                                      <Row>
                                        <Col lg={15} md={15} sm={24} xs={24}>
                                          <div style={{ ...headerDetail, textAlign: 'right' }}>
                                            รวม
                                          </div>
                                        </Col>
                                        <Col lg={3} md={3} sm={24} xs={24}>
                                          <div style={{ ...headerDetail, textAlign: 'right' }}>
                                            {budgetFormat(
                                              editSubActivity?.reduce(
                                                (acc, obj) => acc + obj.subActivityBudget,
                                                0
                                              ) || 0
                                            )}
                                          </div>
                                        </Col>
                                        <Col lg={3} md={3} sm={24} xs={24}>
                                          <div style={{ ...headerDetail, textAlign: 'right' }}>
                                            {budgetFormat(
                                              editSubActivity?.reduce(
                                                (acc, obj) => acc + obj.subActivityUsedBudget,
                                                0
                                              ) || 0
                                            )}
                                          </div>
                                        </Col>
                                        <Col lg={3} md={3} sm={24} xs={24}>
                                          <div
                                            style={{
                                              padding: 8,
                                              textAlign: 'center',
                                            }}
                                          >
                                            <ButtonGroup>
                                              <IconButton
                                                appearance="ghost"
                                                // className="rs-btn-ghost-edit"
                                                icon={
                                                  <Icon
                                                    icon="plus-circle"
                                                    className="bt-gost-icon-radius"
                                                  />
                                                }
                                                onClick={() => {
                                                  if (editSubActivity?.length > 0) {
                                                    onAddSubActivity(
                                                      editSubActivity.length - 1,
                                                      mainVal.activityCode
                                                    )
                                                  } else {
                                                    onAddSubActivity(0, mainVal.activityCode)
                                                  }
                                                }}
                                                style={{ display: 'block' }}
                                                size="sm"
                                              >
                                                เพิ่ม
                                              </IconButton>
                                            </ButtonGroup>
                                          </div>
                                        </Col>
                                      </Row>
                                    </>
                                  ) : (
                                    <>
                                      {mainVal?.subActivity?.map((subVal, subIndex) => {
                                        return (
                                          <>
                                            <Row style={detailBorderCell}>
                                              <Col lg={4} md={4} sm={24} xs={24}>
                                                <div
                                                  style={{
                                                    padding: 8,
                                                    textAlign: 'center',
                                                  }}
                                                >
                                                  {subVal.subActivityCode || ''}
                                                </div>
                                              </Col>
                                              <Col lg={14} md={14} sm={24} xs={24}>
                                                <div
                                                  style={{
                                                    padding: 8,
                                                    textAlign: 'left',
                                                  }}
                                                >
                                                  {subVal.subActivityName || ''}
                                                </div>
                                              </Col>
                                              <Col lg={3} md={3} sm={24} xs={24}>
                                                <div
                                                  style={{
                                                    padding: 8,
                                                    textAlign: 'right',
                                                  }}
                                                >
                                                  {budgetFormat(subVal.subActivityBudget || 0)}
                                                </div>
                                              </Col>
                                              <Col lg={3} md={3} sm={24} xs={24}>
                                                <div
                                                  style={{
                                                    padding: 8,
                                                    textAlign: 'right',
                                                  }}
                                                >
                                                  {budgetFormat(subVal.subActivityUsedBudget || 0)}
                                                </div>
                                              </Col>
                                            </Row>
                                          </>
                                        )
                                      })}
                                      <Row>
                                        <Col lg={18} md={18} sm={24} xs={24}>
                                          <div style={{ ...headerDetail, textAlign: 'right' }}>
                                            รวม
                                          </div>
                                        </Col>
                                        <Col lg={3} md={3} sm={24} xs={24}>
                                          <div style={{ ...headerDetail, textAlign: 'right' }}>
                                            {budgetFormat(
                                              mainVal?.subActivity?.reduce(
                                                (acc, obj) => acc + obj.subActivityBudget,
                                                0
                                              ) || 0
                                            )}
                                          </div>
                                        </Col>
                                        <Col lg={3} md={3} sm={24} xs={24}>
                                          <div style={{ ...headerDetail, textAlign: 'right' }}>
                                            {budgetFormat(
                                              mainVal?.subActivity?.reduce(
                                                (acc, obj) => acc + obj.subActivityUsedBudget,
                                                0
                                              ) || 0
                                            )}
                                          </div>
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                </div>
                              </div>
                            </Col>
                            {isEdit ? (
                              <Col lg={2} md={2} sm={24} xs={24}>
                                <div
                                  style={{
                                    padding: 14,
                                    textAlign: 'center',
                                    marginTop: '20%',
                                  }}
                                >
                                  <SaveButton size="sm" onClick={onSubmit}>
                                    บันทึก
                                  </SaveButton>
                                  {/* <Button appearance="primary" block size="sm">
                                    <Icon icon="save" /> บันทึก
                                  </Button> */}
                                </div>
                              </Col>
                            ) : (
                              <Col lg={2} md={2} sm={24} xs={24}></Col>
                            )}
                          </Row>
                        )}
                      </>
                    )
                  })}
                </Row>
              </Panel>
            </div>
          </>
        )
      })}

      <ConfirmWidget
        title={'ยืนยันการบันทึก'}
        show={isShowConfirm}
        //detail={'ยืนยันการบันทึก'}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={() => {
          setIsShowConfirm(false)
          onSave(saveReq)
        }}
      />

      <ConfirmWidget
        title={'ยืนยันการลบ'}
        show={isShowDeleteConfirm}
        detail={
          editSubActivity &&
          editSubActivity[selectDeleteIndex]?.subActivityCode &&
          `ยืนยันการลบ รหัสกิจกรรมย่อย : ${editSubActivity[selectDeleteIndex].subActivityCode}`
        }
        onCancle={() => {
          setSelectDeleteIndex('')
          setIsShowDeleteConfirm(false)
        }}
        onConfirm={() => {
          setIsShowDeleteConfirm(false)
          onDeleteSubActivity(selectDeleteIndex)
        }}
      />
    </>
  )
}
